// Before deleting this file, please first read the comment in the adjacent sister file before doing so.

// This is a harmless side-effect to prevent the module from being optimized away.
Date.now();
